import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function StickyTopBar() {
  const {
    minutes,
    seconds,
    isUrgent
  } = useCountdown(15);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 right-0 z-50 bg-brand-dark text-white py-2 px-4 shadow-md" data-id="element-302">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-2 md:gap-4 text-sm md:text-base" data-id="element-303">
        <div className="flex items-center gap-2 font-bold text-center" data-id="element-304">
          <span className="animate-pulse" data-id="element-305">⏰</span>
          <span data-id="element-306">OFERTA POR TIEMPO LIMITADO — Cierra en:</span>
          <span className={`font-black text-lg tracking-wider ${isUrgent ? 'text-red-500 animate-blink' : 'text-brand-primary'}`} data-id="element-307">
            {formatTime(minutes)}:{formatTime(seconds)}
          </span>
        </div>
        <a href="https://checkout.guiadigital360.online/cart/43920784949317:1" className="bg-brand-primary hover:bg-[#0284C7] text-white font-bold py-1 px-4 rounded-full text-sm transition-colors whitespace-nowrap" data-id="element-308">
          ASEGURAR MI PRECIO
        </a>
      </div>
    </div>;
}